@if (inDropdown) {
	<app-single-select-list [opties]="allOptions" [selectedOptie]="getSelected()" (onOptieClicked)="selectOption($event)"></app-single-select-list>
} @else {
	<app-single-select-dropdown placeholder="Alle" [opties]="allOptions" [selectedOptie]="getSelected()" (onOptieClicked)="selectOption($event)">
	</app-single-select-dropdown>
	@if (currentOption !== "Aangepast") {
		<app-checkbox label="Incl. huidig schooljaar" [value]="inclHuidig" (valueChange)="selectHuidig($event)"></app-checkbox>
	}
}
